var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"text-center"},[_c('b-row',[_c('b-col',[_c('h2',{staticClass:"text d-flex w-100",class:_vm.titleClasses,style:({ color: _vm.textColor })},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")]),_vm._v(" "),_c('BrandsBlock',{attrs:{"padding":7,"inline-desktop":true,"brands":_vm.brands}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }